// extracted by mini-css-extract-plugin
export var closeButton = "custom-modal-module--close-button--36b11";
export var container = "custom-modal-module--container--be43d";
export var titleText = "custom-modal-module--title-text--444d6";
export var topImage = "custom-modal-module--top-image--b7e40";